import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import QuienesSomos from './pages/QuienesSomos';
import QueHacemos from './pages/QueHacemos';
import GestionInmobiliaria from './pages/GestionInmobiliaria';
import InversionInmobiliaria from './pages/InversionInmobiliaria';
import BodegajeIndustrial from './pages/BodegajeIndustrial';
import DesarrolloSoftware from './pages/DesarrolloSoftware';
import Contacto from './pages/Contacto';
import LeitpalelPrivacy from './pages/LeitpalelPrivacy';
import LeitpalelTerms from './pages/LeitpalelTerms';
import LeitpalelDeleteAccount from './pages/LeitpalelDeleteAccount';
import Leitpalel from './pages/Leitpalel';
import Cachodice from './pages/Cachodice';
import CIS from './pages/CIS';
import InmobiliariaManager from './pages/InmobiliariaManager';
import Recetario from './pages/Recetario';
import CachodicePrivacy from './pages/CachodicePrivacy';
import CachodiceTerms from './pages/CachodiceTerms';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/quienes-somos" element={<QuienesSomos />} />
              <Route path="/que-hacemos" element={<QueHacemos />} />
              <Route path="/que-hacemos/gestion-inmobiliaria" element={<GestionInmobiliaria />} />
              <Route path="/que-hacemos/inversion-inmobiliaria" element={<InversionInmobiliaria />} />
              <Route path="/que-hacemos/bodegaje-industrial" element={<BodegajeIndustrial />} />
              <Route path="/que-hacemos/desarrollo-software" element={<DesarrolloSoftware />} />
              <Route path="/que-hacemos/desarrollo-software/leitpalel/privacy" element={<LeitpalelPrivacy />} />
              <Route path="/que-hacemos/desarrollo-software/leitpalel/terms" element={<LeitpalelTerms />} />
              <Route path="/leitpalel" element={<Leitpalel />} />
              <Route path="/leitpalel/privacy" element={<LeitpalelPrivacy />} />
              <Route path="/leitpalel/terms" element={<LeitpalelTerms />} />
              <Route path="/leitpalel/delete-account" element={<LeitpalelDeleteAccount />} />
              <Route path="/cachodice" element={<Cachodice />} />
              <Route path="/cachodice/privacy" element={<CachodicePrivacy />} />
              <Route path="/cachodice/terms" element={<CachodiceTerms />} />
              <Route path="/cis" element={<CIS />} />
              <Route path="/inmobiliaria-manager" element={<InmobiliariaManager />} />
              <Route path="/recetario" element={<Recetario />} />
              <Route path="/contacto" element={<Contacto />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
